import * as URLS from './urls'

// SAME BREAKPOINT AS bootstrap
const BREAKPOINTS = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1300
}

export {
  BREAKPOINTS,
  URLS
}
